import { Table, Button, Tooltip } from "antd";
import { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import UserEditModal from "./UserEditModal";

export default function UserAdminIndex({ users, loading, onUpdateSuccess, onDataChange }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const showEditModal = (user) => {
    setEditingUser(user);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingUser(null);
  };

  const columns = [
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Email</span>,
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Nombre</span>,
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => (a.nombre || "").localeCompare(b.nombre || ""),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Apellido</span>,
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => (a.apellido || "").localeCompare(b.apellido || ""),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Rol</span>,
      dataIndex: "rol",
      key: "rol",
      sorter: (a, b) => (a.rol || "").localeCompare(b.rol || ""),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Activo</span>,
      dataIndex: "activo",
      key: "activo",
      render: (activo) => (activo ? "Sí" : "No"),
      sorter: (a, b) => (a.activo === b.activo ? 0 : a.activo ? -1 : 1),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Acciones</span>,
      key: "acciones",
      width: 100,
      render: (_, record) => (
        <Tooltip title="Editar Usuario">
          <Button type="primary" shape="circle" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
        </Tooltip>
      ),
    },
  ];

  return (
    <div style={{ fontSize: "13px" }}>
      <Table
        size="small"
        dataSource={users}
        columns={columns}
        loading={loading}
        rowKey="email"
        onChange={(pagination, filters, sorter, extra) => {
          if (onDataChange) {
            onDataChange(extra.currentDataSource);
          }
        }}
        pagination={{
          defaultPageSize: 25,
          showSizeChanger: true,
          showLessItems: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
      />
      {editingUser && (
        <UserEditModal visible={isModalVisible} onCancel={handleCancel} user={editingUser} onUpdateSuccess={onUpdateSuccess} />
      )}
    </div>
  );
}
